export default __webpack_public_path__ + "static/media/Illustration.ba42afba.png";